import {compileGrammar, parse} from "@cranq/bipt-parser";
import {grammar} from "./grammar/grammar";
import {ChunkType} from "./types/ChunkType";
import {IncludeChunk} from "./types/IncludeChunk";
import {NodeChunk} from "./types/NodeChunk";
import {ScriptChunk} from "./types/ScriptChunk";
import {TypeChunk} from "./types/TypeChunk";

const compiledGrammar = compileGrammar(grammar);

export function scriptToScriptChunk(
  script: string
): ScriptChunk {
  const parsed = parse(
    script,
    grammar.Script.childRules || [],
    compiledGrammar);
  return {
    type: ChunkType.Script,
    captures: [""],
    children: parsed as Array<IncludeChunk
      | NodeChunk
      | TypeChunk>,
    offset: {line: 0, column: 0}
  };
}
